var map = {
	"./commodityInfo": "Lvw7",
	"./commodityInfo/": "Lvw7",
	"./commodityInfo/index": "Lvw7",
	"./commodityInfo/index.vue": "Lvw7",
	"./employeeBilling": "sAbc",
	"./employeeBilling/": "sAbc",
	"./employeeBilling/index": "sAbc",
	"./employeeBilling/index.vue": "sAbc",
	"./employeeCommission": "SkvP",
	"./employeeCommission/": "SkvP",
	"./employeeCommission/index": "SkvP",
	"./employeeCommission/index.vue": "SkvP",
	"./employeeHandover": "PU0f",
	"./employeeHandover/": "PU0f",
	"./employeeHandover/index": "PU0f",
	"./employeeHandover/index.vue": "PU0f",
	"./errorPage/401": "eRLo",
	"./errorPage/401.vue": "eRLo",
	"./errorPage/404": "AejC",
	"./errorPage/404.vue": "AejC",
	"./goodsReturnOrder": "7pw2",
	"./goodsReturnOrder/": "7pw2",
	"./goodsReturnOrder/index": "7pw2",
	"./goodsReturnOrder/index.vue": "7pw2",
	"./goodsSaleOrder": "FELz",
	"./goodsSaleOrder/": "FELz",
	"./goodsSaleOrder/index": "FELz",
	"./goodsSaleOrder/index.vue": "FELz",
	"./home/Login": "4Agw",
	"./home/Login.vue": "4Agw",
	"./home/components/banner": "F0fe",
	"./home/components/banner.vue": "F0fe",
	"./home/components/equipMent": "5jAb",
	"./home/components/equipMent.vue": "5jAb",
	"./home/components/fooTer": "vMUr",
	"./home/components/fooTer.vue": "vMUr",
	"./home/components/intro": "f5RI",
	"./home/components/intro.vue": "f5RI",
	"./home/components/jbanner": "ZnjG",
	"./home/components/jbanner.vue": "ZnjG",
	"./home/components/jintro1": "WNMj",
	"./home/components/jintro1.vue": "WNMj",
	"./home/components/jintro2": "KICs",
	"./home/components/jintro2.vue": "KICs",
	"./home/components/productCharacteristic": "j+iK",
	"./home/components/productCharacteristic.vue": "j+iK",
	"./home/components/productmeal": "qupG",
	"./home/components/productmeal.vue": "qupG",
	"./home/components/setMeal": "PKTH",
	"./home/components/setMeal.vue": "PKTH",
	"./home/home": "zKIK",
	"./home/home.vue": "zKIK",
	"./home/home2": "IhPB",
	"./home/home2.vue": "IhPB",
	"./home/loginNew": "f6NP",
	"./home/loginNew.vue": "f6NP",
	"./homenew/Home": "xCQ8",
	"./homenew/Home.vue": "xCQ8",
	"./homenew/components": "rTGn",
	"./homenew/components/": "rTGn",
	"./homenew/components/AppMain": "1vMU",
	"./homenew/components/AppMain.vue": "1vMU",
	"./homenew/components/HeaderBar": "VmRD",
	"./homenew/components/HeaderBar.vue": "VmRD",
	"./homenew/components/SideBar": "djwo",
	"./homenew/components/SideBar.vue": "djwo",
	"./homenew/components/index": "rTGn",
	"./homenew/components/index.ts": "rTGn",
	"./internalH5/Login": "en66",
	"./internalH5/Login.vue": "en66",
	"./internalH5/abnormalDetail": "4hfc",
	"./internalH5/abnormalDetail.vue": "4hfc",
	"./internalH5/abnormalList": "mJ5g",
	"./internalH5/abnormalList.vue": "mJ5g",
	"./memberRecharge": "/Bvf",
	"./memberRecharge/": "/Bvf",
	"./memberRecharge/index": "/Bvf",
	"./memberRecharge/index.vue": "/Bvf",
	"./padViews/Login": "tNEa",
	"./padViews/Login.vue": "tNEa",
	"./padViews/Login2": "FgLz",
	"./padViews/Login2.vue": "FgLz",
	"./padViews/allot/addAllot": "xDZw",
	"./padViews/allot/addAllot.vue": "xDZw",
	"./padViews/allot/allot": "wIrQ",
	"./padViews/allot/allot.vue": "wIrQ",
	"./padViews/allot/components/inallot": "nVJF",
	"./padViews/allot/components/inallot.vue": "nVJF",
	"./padViews/allot/components/outallot": "9CQt",
	"./padViews/allot/components/outallot.vue": "9CQt",
	"./padViews/allot/components/paginationPanel": "BtCq",
	"./padViews/allot/components/paginationPanel.vue": "BtCq",
	"./padViews/allot/components/searchDia": "MMYz",
	"./padViews/allot/components/searchDia.vue": "MMYz",
	"./padViews/allot/components/selectProduct": "M1ee",
	"./padViews/allot/components/selectProduct.vue": "M1ee",
	"./padViews/allot/viewAllot": "eLiu",
	"./padViews/allot/viewAllot.vue": "eLiu",
	"./padViews/cashier/cashier": "mjsV",
	"./padViews/cashier/cashier.vue": "mjsV",
	"./padViews/cashier/changeOrderDetail": "DOy9",
	"./padViews/cashier/changeOrderDetail.vue": "DOy9",
	"./padViews/cashier/components/cashierOperate": "4v2U",
	"./padViews/cashier/components/cashierOperate.vue": "4v2U",
	"./padViews/cashier/components/changeOrder": "cWsJ",
	"./padViews/cashier/components/changeOrder.vue": "cWsJ",
	"./padViews/cashier/components/changePricePanel": "kUm8",
	"./padViews/cashier/components/changePricePanel.vue": "kUm8",
	"./padViews/cashier/components/changeSpecANum": "YwJe",
	"./padViews/cashier/components/changeSpecANum.vue": "YwJe",
	"./padViews/cashier/components/confirmReturnPanel": "3cWq",
	"./padViews/cashier/components/confirmReturnPanel.vue": "3cWq",
	"./padViews/cashier/components/couponPop": "8Tpu",
	"./padViews/cashier/components/couponPop.vue": "8Tpu",
	"./padViews/cashier/components/editReturnProduct": "qSyO",
	"./padViews/cashier/components/editReturnProduct.vue": "qSyO",
	"./padViews/cashier/components/exchangeReminder": "puh+",
	"./padViews/cashier/components/exchangeReminder.vue": "puh+",
	"./padViews/cashier/components/leftProductDetail": "EtOo",
	"./padViews/cashier/components/leftProductDetail.vue": "EtOo",
	"./padViews/cashier/components/memeberList": "aN0P",
	"./padViews/cashier/components/memeberList.vue": "aN0P",
	"./padViews/cashier/components/morePay": "6Fdp",
	"./padViews/cashier/components/morePay.vue": "6Fdp",
	"./padViews/cashier/components/mulChangePricePanel": "hEBf",
	"./padViews/cashier/components/mulChangePricePanel.vue": "hEBf",
	"./padViews/cashier/components/noCodeProduct": "EEA0",
	"./padViews/cashier/components/noCodeProduct.vue": "EEA0",
	"./padViews/cashier/components/onlineOrder": "GtaT",
	"./padViews/cashier/components/onlineOrder.vue": "GtaT",
	"./padViews/cashier/components/payPanel": "3cyy",
	"./padViews/cashier/components/payPanel.vue": "3cyy",
	"./padViews/cashier/components/payResultPanel": "uRlw",
	"./padViews/cashier/components/payResultPanel.vue": "uRlw",
	"./padViews/cashier/components/productDetail": "ovvv",
	"./padViews/cashier/components/productDetail.vue": "ovvv",
	"./padViews/cashier/components/productList": "DfM6",
	"./padViews/cashier/components/productList.vue": "DfM6",
	"./padViews/cashier/components/remarkPanel": "PTLu",
	"./padViews/cashier/components/remarkPanel.vue": "PTLu",
	"./padViews/cashier/components/returnDetailPopPanel": "0Tco",
	"./padViews/cashier/components/returnDetailPopPanel.vue": "0Tco",
	"./padViews/cashier/components/returnOrder": "Fuku",
	"./padViews/cashier/components/returnOrder.vue": "Fuku",
	"./padViews/cashier/components/returnResultPanel": "QaHo",
	"./padViews/cashier/components/returnResultPanel.vue": "QaHo",
	"./padViews/cashier/components/scanPanel": "pyNL",
	"./padViews/cashier/components/scanPanel.vue": "pyNL",
	"./padViews/cashier/components/selectCoupon": "SZzh",
	"./padViews/cashier/components/selectCoupon.vue": "SZzh",
	"./padViews/cashier/components/selectMember": "Z+Ym",
	"./padViews/cashier/components/selectMember.vue": "Z+Ym",
	"./padViews/cashier/components/selectReturnProduct": "McxG",
	"./padViews/cashier/components/selectReturnProduct.vue": "McxG",
	"./padViews/cashier/components/settlementDesk": "FiWO",
	"./padViews/cashier/components/settlementDesk.vue": "FiWO",
	"./padViews/cashier/onlineOrderDetail": "sOzr",
	"./padViews/cashier/onlineOrderDetail.vue": "sOzr",
	"./padViews/changeShifts/changeShifts": "FQ8u",
	"./padViews/changeShifts/changeShifts.vue": "FQ8u",
	"./padViews/changeShifts/components/goodsDetails": "ejs/",
	"./padViews/changeShifts/components/goodsDetails.vue": "ejs/",
	"./padViews/home/Home": "OcZA",
	"./padViews/home/Home.vue": "OcZA",
	"./padViews/mainPage/components/headPanel": "Y9fr",
	"./padViews/mainPage/components/headPanel.vue": "Y9fr",
	"./padViews/mainPage/mainPage": "iG/e",
	"./padViews/mainPage/mainPage.vue": "iG/e",
	"./padViews/notice/notice": "pBcN",
	"./padViews/notice/notice.vue": "pBcN",
	"./padViews/product/addProduct": "uX2N",
	"./padViews/product/addProduct.vue": "uX2N",
	"./padViews/product/components/classManage": "He9F",
	"./padViews/product/components/classManage.vue": "He9F",
	"./padViews/product/components/info": "ehmP",
	"./padViews/product/components/info.vue": "ehmP",
	"./padViews/product/components/productDetail": "n8Gz",
	"./padViews/product/components/productDetail.vue": "n8Gz",
	"./padViews/product/components/specs": "4rsh",
	"./padViews/product/components/specs.vue": "4rsh",
	"./padViews/product/editProduct": "kLY+",
	"./padViews/product/editProduct.vue": "kLY+",
	"./padViews/product/product": "h9//",
	"./padViews/product/product.vue": "h9//",
	"./padViews/product/viewProduct": "K1aO",
	"./padViews/product/viewProduct.vue": "K1aO",
	"./padViews/protocol/protocol": "y2Xv",
	"./padViews/protocol/protocol.vue": "y2Xv",
	"./padViews/protocolPrivacy/protocolPrivacy": "ndD1",
	"./padViews/protocolPrivacy/protocolPrivacy.vue": "ndD1",
	"./padViews/report/components/deliveryDetail": "PNaC",
	"./padViews/report/components/deliveryDetail.vue": "PNaC",
	"./padViews/report/components/deliverybb": "Fmsi",
	"./padViews/report/components/deliverybb.vue": "Fmsi",
	"./padViews/report/components/detail": "xd5t",
	"./padViews/report/components/detail.vue": "xd5t",
	"./padViews/report/components/goodsbb": "25ts",
	"./padViews/report/components/goodsbb.vue": "25ts",
	"./padViews/report/components/goodsjydetail": "pR+m",
	"./padViews/report/components/goodsjydetail.vue": "pR+m",
	"./padViews/report/components/salebb": "6xRT",
	"./padViews/report/components/salebb.vue": "6xRT",
	"./padViews/report/components/salezl": "yfwL",
	"./padViews/report/components/salezl.vue": "yfwL",
	"./padViews/report/components/staffbb": "e5R9",
	"./padViews/report/components/staffbb.vue": "e5R9",
	"./padViews/report/components/vipbb": "mQ1L",
	"./padViews/report/components/vipbb.vue": "mQ1L",
	"./padViews/report/report": "bnbY",
	"./padViews/report/report.vue": "bnbY",
	"./padViews/setting/chooseBlue": "Cj5X",
	"./padViews/setting/chooseBlue.vue": "Cj5X",
	"./padViews/setting/components/changeMbTip": "6SPG",
	"./padViews/setting/components/changeMbTip.vue": "6SPG",
	"./padViews/setting/components/dpInfo": "GXMX",
	"./padViews/setting/components/dpInfo.vue": "GXMX",
	"./padViews/setting/components/dpSetting": "EXr7",
	"./padViews/setting/components/dpSetting.vue": "EXr7",
	"./padViews/setting/components/mmSetting": "CxNN",
	"./padViews/setting/components/mmSetting.vue": "CxNN",
	"./padViews/setting/components/pjSetting": "KTo8",
	"./padViews/setting/components/pjSetting.vue": "KTo8",
	"./padViews/setting/components/selectLabelPaper": "uiS/",
	"./padViews/setting/components/selectLabelPaper.vue": "uiS/",
	"./padViews/setting/components/storeInfo": "v7fc",
	"./padViews/setting/components/storeInfo.vue": "v7fc",
	"./padViews/setting/components/sySetting": "M9Pb",
	"./padViews/setting/components/sySetting.vue": "M9Pb",
	"./padViews/setting/components/xpInfo": "rmJI",
	"./padViews/setting/components/xpInfo.vue": "rmJI",
	"./padViews/setting/components/xpSetting": "hxST",
	"./padViews/setting/components/xpSetting.vue": "hxST",
	"./padViews/setting/components/xtSetting": "qMkr",
	"./padViews/setting/components/xtSetting.vue": "qMkr",
	"./padViews/setting/components/zfSetting": "PgIy",
	"./padViews/setting/components/zfSetting.vue": "PgIy",
	"./padViews/setting/setting": "BiQB",
	"./padViews/setting/setting.vue": "BiQB",
	"./padViews/shopUpdate": "QY5K",
	"./padViews/shopUpdate.vue": "QY5K",
	"./padViews/staff/components/addRolePanel": "nA/w",
	"./padViews/staff/components/addRolePanel.vue": "nA/w",
	"./padViews/staff/components/commissionRule": "rJBB",
	"./padViews/staff/components/commissionRule.vue": "rJBB",
	"./padViews/staff/components/info": "qRnB",
	"./padViews/staff/components/info.vue": "qRnB",
	"./padViews/staff/components/roleAuth": "F0C6",
	"./padViews/staff/components/roleAuth.vue": "F0C6",
	"./padViews/staff/staff": "GPdg",
	"./padViews/staff/staff.vue": "GPdg",
	"./padViews/stock/addFullInventory": "to72",
	"./padViews/stock/addFullInventory.vue": "to72",
	"./padViews/stock/addInventory": "NkXF",
	"./padViews/stock/addInventory.vue": "NkXF",
	"./padViews/stock/components/fullinventory": "SX+8",
	"./padViews/stock/components/fullinventory.vue": "SX+8",
	"./padViews/stock/components/info": "CXUN",
	"./padViews/stock/components/info.vue": "CXUN",
	"./padViews/stock/components/inventory": "FO/j",
	"./padViews/stock/components/inventory.vue": "FO/j",
	"./padViews/stock/components/inventoryDetail": "906j",
	"./padViews/stock/components/inventoryDetail.vue": "906j",
	"./padViews/stock/components/pdTipPanel": "agao",
	"./padViews/stock/components/pdTipPanel.vue": "agao",
	"./padViews/stock/components/remarkPanel": "AvP9",
	"./padViews/stock/components/remarkPanel.vue": "AvP9",
	"./padViews/stock/components/supplier": "HZvX",
	"./padViews/stock/components/supplier.vue": "HZvX",
	"./padViews/stock/components/unFinishProduct": "uwmz",
	"./padViews/stock/components/unFinishProduct.vue": "uwmz",
	"./padViews/stock/fullInventoryDetail": "JIAG",
	"./padViews/stock/fullInventoryDetail.vue": "JIAG",
	"./padViews/stock/stock": "eIX7",
	"./padViews/stock/stock.vue": "eIX7",
	"./padViews/vip/components/addVipPanel": "VNfP",
	"./padViews/vip/components/addVipPanel.vue": "VNfP",
	"./padViews/vip/components/balanceDetail": "mG/l",
	"./padViews/vip/components/balanceDetail.vue": "mG/l",
	"./padViews/vip/components/info": "4Vv0",
	"./padViews/vip/components/info.vue": "4Vv0",
	"./padViews/vip/components/integralSet": "+BZt",
	"./padViews/vip/components/integralSet.vue": "+BZt",
	"./padViews/vip/components/levelSet": "7qEb",
	"./padViews/vip/components/levelSet.vue": "7qEb",
	"./padViews/vip/components/payPanel": "YkdT",
	"./padViews/vip/components/payPanel.vue": "YkdT",
	"./padViews/vip/components/returnOrder": "Bolo",
	"./padViews/vip/components/returnOrder.vue": "Bolo",
	"./padViews/vip/components/saleOrder": "+xLT",
	"./padViews/vip/components/saleOrder.vue": "+xLT",
	"./padViews/vip/components/scoreDetail": "pN3/",
	"./padViews/vip/components/scoreDetail.vue": "pN3/",
	"./padViews/vip/vip": "CZkS",
	"./padViews/vip/vip.vue": "CZkS",
	"./padViews/vip/vipDetail": "xmCn",
	"./padViews/vip/vipDetail.vue": "xmCn",
	"./padViews/vip/vipRecharge": "TjpP",
	"./padViews/vip/vipRecharge.vue": "TjpP",
	"./product": "SKi1",
	"./product/": "SKi1",
	"./product/index": "SKi1",
	"./product/index.vue": "SKi1",
	"./returnOrder": "J/Qo",
	"./returnOrder/": "J/Qo",
	"./returnOrder/index": "J/Qo",
	"./returnOrder/index.vue": "J/Qo",
	"./saleOrder": "67RJ",
	"./saleOrder/": "67RJ",
	"./saleOrder/index": "67RJ",
	"./saleOrder/index.vue": "67RJ",
	"./shopJYZL": "Xk8k",
	"./shopJYZL/": "Xk8k",
	"./shopJYZL/index": "Xk8k",
	"./shopJYZL/index.vue": "Xk8k",
	"./storePayment": "balz",
	"./storePayment/": "balz",
	"./storePayment/index": "balz",
	"./storePayment/index.vue": "balz",
	"./wdOrder": "3197",
	"./wdOrder/": "3197",
	"./wdOrder/index": "3197",
	"./wdOrder/index.vue": "3197",
	"./wdStatistics": "+iAf",
	"./wdStatistics/": "+iAf",
	"./wdStatistics/index": "+iAf",
	"./wdStatistics/index.vue": "+iAf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g9CB";


//////////////////
// WEBPACK FOOTER
// ./src/views ^\.\/.*$
// module id = g9CB
// module chunks = 1